import React from 'react';

import { GridFilterItem, GridFilterOperator } from '@mui/x-data-grid';

import styled from 'styled-components';

import { MenuItem } from '@mui/material';

import { PickerProps } from 'components/Grid/operators/types';

import { StyledSelect } from 'components/Input/styles';
import { createFilterRegex } from 'utils/regex';

export const StyledMenuItem = styled(MenuItem)`
  font-size: 1.3rem;
  line-height: 2rem;
  p {
    margin: 0;
  }
`;

const AudienceFilteringOperator: React.FunctionComponent<PickerProps> = ({ applyValue, item, ...props }) => (
  <StyledSelect
    {...props}
    value={item.value}
    fullWidth
    onChange={(newValue) => applyValue({ ...item, value: newValue.target.value })}
  >
    <StyledMenuItem key="user" value="user">
      <p>User</p>
    </StyledMenuItem>
    <StyledMenuItem key="public" value="public">
      <p>Public</p>
    </StyledMenuItem>
    <StyledMenuItem key="public,user" value="public,user">
      <p>Public & User</p>
    </StyledMenuItem>
  </StyledSelect>
);

export default [
  {
    label: 'is',
    value: 'is',
    getApplyFilterFn: (filterItem: GridFilterItem) => {
      if (!filterItem.value) {
        return null;
      }
      const filterRegex = createFilterRegex(filterItem.value);
      return ({ value }: { value: string }): boolean => (value != null ? filterRegex.test(value.toString()) : false);
    },
    InputComponent: AudienceFilteringOperator,
    InputComponentProps: { value: null },
    getValueAsString: (value: string) => value,
  },
] as unknown as GridFilterOperator[];
